import React from 'react';
import cls from './FileInput.module.css';
import classNames from 'classnames';

export const OldFilesItem = ({ file, oldFilesHandler, isDisabled }) => {
    return (
        <div className={classNames(cls.oldFilesItem)}>
            {isDisabled ? (
                <span>
                    {decodeURI(file.original_name)}
                    {file.extension}
                </span>
            ) : (
                <a href={file.original_url ? file.original_url : file.url} target="_blank">
                    {decodeURI(file.original_name)}
                    {file.extension}
                </a>
            )}
            <span onClick={() => oldFilesHandler(file.id)} className={classNames(cls.deleteItem)}>
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.74561 2.74561C2.86282 2.62845 3.02176 2.56262 3.18749 2.56262C3.35322 2.56262 3.51216 2.62845 3.62936 2.74561L5.99999 5.11624L8.37061 2.74561C8.42827 2.68592 8.49723 2.63831 8.57349 2.60555C8.64974 2.5728 8.73175 2.55555 8.81474 2.55483C8.89773 2.55411 8.98002 2.56993 9.05683 2.60135C9.13365 2.63278 9.20343 2.67918 9.26211 2.73787C9.32079 2.79655 9.3672 2.86633 9.39863 2.94314C9.43005 3.01995 9.44587 3.10225 9.44515 3.18524C9.44443 3.26823 9.42718 3.35024 9.39443 3.42649C9.36167 3.50274 9.31406 3.57171 9.25436 3.62936L6.88374 5.99999L9.25436 8.37062C9.36821 8.48849 9.43121 8.64637 9.42979 8.81024C9.42836 8.97411 9.36263 9.13087 9.24675 9.24675C9.13087 9.36263 8.97411 9.42836 8.81024 9.42979C8.64637 9.43121 8.48849 9.36821 8.37061 9.25436L5.99999 6.88374L3.62936 9.25436C3.51149 9.36821 3.35361 9.43121 3.18974 9.42979C3.02586 9.42836 2.86911 9.36263 2.75323 9.24675C2.63735 9.13087 2.57162 8.97411 2.57019 8.81024C2.56877 8.64637 2.63176 8.48849 2.74561 8.37062L5.11624 5.99999L2.74561 3.62936C2.62844 3.51216 2.56262 3.35322 2.56262 3.18749C2.56262 3.02176 2.62844 2.86282 2.74561 2.74561Z"
                        fill="#757575"
                    />
                </svg>
            </span>
        </div>
    );
};
